// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Footer-base__wbjVS{margin-right:calc(-1*var(--size-4));margin-bottom:calc(-1*var(--size-4));margin-left:calc(-1*var(--size-4));border-top:var(--size-0_25) solid var(--gray-a4)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "Footer-base__wbjVS"
};
export default ___CSS_LOADER_EXPORT___;
